<template>
    <div
      class="mt-3 px-5">
      <v-layout wrap>
        <v-flex>
          <section>

            <v-row>
              <v-col cols="12" md="3">

                <v-card flat class="pa-3 px-7 border-radius-card py-5" style="border-radius: 6px; background-color: #fff;">

                  <div class="d-flex flex-column align-center">

                    <v-avatar size="150" class="mx-auto">
                      <v-img contain :src="form.image_url !== undefined && form.image_url !== '' ? form.image_url : require('@/assets/image/member_default.png')"></v-img>
                    </v-avatar>
                  </div>

                  <div class="text-center mt-3 font_weight_600" style="font-size: 1.25rem;" :style="{ color: set_color }">
                    {{ user.name }}
                  </div>

                  <div class="px-5 mt-3">
                    <div class="d-flex align-center mb-2">
                      <div>
                        <v-icon size="18" color="#868b93">mdi-medal-outline</v-icon>
                      </div>
                      <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                        {{ user.cat_title }}
                      </div>
                    </div>

                    <div class="d-flex align-center mb-2">
                      <div>
                        <v-icon size="18" color="#868b93">mdi-email-outline</v-icon>
                      </div>
                      <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                        {{ user.email }}
                      </div>
                    </div>


                    <div class="d-flex align-center">
                      <div>
                        <v-icon size="18" color="#868b93">mdi-phone-outline</v-icon>
                      </div>
                      <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                        {{ user.mobilephone }}
                      </div>
                    </div>
                  </div>

                </v-card>

              </v-col>
              <v-col cols="12" md="9">
                <v-card flat class="pa-3 px-7 border-radius-card" style="border-radius: 6px; background-color: #fff;">
                  <div>
                    <v-tabs
                      v-model="tabs"
                      dense
                      background-color="transparent"
                      slider-size="1"
                      color="#240087">
                      <v-tab
                        v-for="(item, index) in tab"
                        :key="index"
                        v-on:change="changeQuery(item.link)">
                        <span
                          class="body-2 font-weight-medium text-capitalize">
                          {{ item.title }}
                        </span>
                      </v-tab>
                    </v-tabs>
                    <v-divider style="border-color: #EBEEF2;"></v-divider>
                  </div>
      
      
                  <div>
      
                    <General v-if="tabs === 0"
                      :form="form" />
      
                    <Password v-if="tabs === 1" />
      
                    <!-- <Preferences v-if="tabs === 1" /> -->
                  </div>
                </v-card>
              </v-col>
            </v-row>
  
  
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    export default {
      data() {
        return {
          tabs: 0,
          tab: [
            {
              title: 'General',
              link: '/profile?menu=profile'
            },
            // {
            //   title: 'Preferences',
            //   link: '/profile?menu=preferences'
            // },
            {
              title: 'Security',
              link: '/profile?menu=security'
            }
          ],
  
  
          form: {},
  
          process: {
            load: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      computed: {
        user() {
          return this.$store.state.user;
        },
        rps() {
          return this.$vuetify.breakpoint.name
        },
        company () {
          return this.$store.state.company
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r+93}, ${g+120}, ${b+12})`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.05)`
        },
  
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
  
        years () {
          let max = new Date().getFullYear()+2, min = max - 2, years = []
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      components: {
        General: () => import(/* webpackPrefetch: true */ '@/components/profile/general.vue'),
        Password: () => import(/* webpackPrefetch: true */ '@/components/profile/password.vue')
      },
      watch: {
        '$route.query.menu': function(val) {
          this.changeLink(val)
        }
      },
      mounted () {
        this.fetchDetail()
        this.changeLink(this.$route.query.menu)
      },
      methods: {
        async fetchDetail () {
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? `pegawai/account/data` : `account/data`
          await get(`${url}`)
          .then(response => {
            let res = response.data
  
            this.process.load = false
              
            if (res.status === 200) {
              this.form = res.results.data
              this.form.mobilephone = res.results.data.mobilephone.replace(/^0/, '').replace(/^62/, '')
            }
          })
        },
  
        changeLink (query) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          
          if (query !== undefined) {
            this.tabs = query === 'profile' ? 0 : 1
          } else {
            this.tabs = 0
          this.$router.push(this.tab[this.tabs].link)
          }
        },
        changeQuery (link) {
          this.$router.push(link)
        },
  
        updateTime () {
          let cd = new Date()
  
          this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
        },
        zeroPadding (num, digit) {
          let zero = ''
  
          for(let i = 0; i < digit; i++) {
            zero += '0'
          }
          return (zero + num).slice(-digit)
        }
      }
    }
  </script>
  
  <style>
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background-color: #F5F5F5;
  
      /* background-color: #718EBF; */
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 5px;
    }
  
  
    ::-webkit-scrollbar-thumb{
      border-radius: 5px;
      /* background-color: #718EBF; */
    }
  </style>